module.exports = __webpack_public_path__ + "assets/img/button-home.9034c766.svg";